module.exports = __webpack_public_path__ + "static/media/feed.6e52434e.svg";